import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function useAgs() {
  const [ags, setAgs] = useState("");
  const userData = useSelector((state) => state.user?.data);
  const selectedObserverAgs = useSelector(
    (state) => state.observer.selectedAgs
  );

  useEffect(() => {
    if (userData) {
      if (selectedObserverAgs) {
        setAgs(selectedObserverAgs);
      } else if (userData?.subscriber) {
        setAgs(userData?.subscriber?.ags);
      } else {
        setAgs(Object.keys(userData?.roles)[0]);
      }
    }
  }, [selectedObserverAgs, userData]);

  return ags;
}

export default useAgs;

// import { useSelector } from "react-redux";

// function useAgs() {
//   const roles = useSelector((state) => state.login.data?.user?.roles);

//   const agsKeys = roles && Object.keys(roles);
//   return agsKeys;
// }

// export default useAgs;
